import { render } from "./ProductList.vue?vue&type=template&id=41723a12&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=41723a12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41723a12"]])

export default __exports__